<script setup>
import { range } from 'lodash-es';
import { storeToRefs } from 'pinia';
import { useSectionStore } from '@/store/sections';

const { current, length } = storeToRefs(useSectionStore());
</script>

<template>
    <div class="mb-4 grid grid-cols-3 gap-2">
        <template v-for="sectionIndex in range(length)" :key="sectionIndex">
            <div
                class="w-full bg-gray-200 rounded-full dark:bg-gray-700 h-1.5 text-xs leading-none"
            >
                <div
                    v-if="current > sectionIndex"
                    class="rounded-full font-medium text-blue-100 text-center p-0.5 bg-gray-600 h-1.5 text-xs leading-none"
                    style="width: 100%"
                ></div>
            </div>
        </template>
    </div>
</template>
